@if (isLoading()) {
  <div
    class="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black/50 backdrop-blur-sm z-100000"
  >
    <hlm-spinner />
  </div>
}
